// Extended Gemstone Chart Reports
import React, { useState, useEffect } from "react";

import GemstoneReportsCutComp from "../../ChartsGroup/GemstoneReportsCharts/GemstoneReportsCutComp";
import GemstoneReportsShapeComp from "../../ChartsGroup/GemstoneReportsCharts/GemstoneReportsShapeComp";
import GemstoneReportsClarityComp from "../../ChartsGroup/GemstoneReportsCharts/GemstoneReportsClarityComp";
import GemstoneReportsGemTypeComp from "../../ChartsGroup/GemstoneReportsCharts/GemstoneReportsGemTypeComp";
import GemstoneReportsCertificateComp from "../../ChartsGroup/GemstoneReportsCharts/GemstoneReportsCertificateComp";
import GemstoneReportsCutGradeComp from "../../ChartsGroup/GemstoneReportsCharts/GemstoneReportsCutGradeComp";
import GemstoneReportsColorComp from "../../ChartsGroup/GemstoneReportsCharts/GemstoneReportsColorComp";
import GemstoneReportsSizeComp from "../../ChartsGroup/GemstoneReportsCharts/GemstoneReportsSizeComp";
import GemstoneReportsClicksComp from "../../ChartsGroup/GemstoneReportsCharts/GemstoneReportsClicksComp";
import GemstoneReportsPriceComp from "../../ChartsGroup/GemstoneReportsCharts/GemstoneReportsPriceComp";
import ReportKpiBand from "../../ChartsGroup/GemstoneReportsCharts/ReportKpiBand";
import ReportInsight from "../../ChartsGroup/GemstoneReportsCharts/ReportInsight";
import ReportTabs from "../../ChartsGroup/GemstoneReportsCharts/ReportTabs";
import { useTranslation } from "react-i18next";
import ReportsGemstoneService from "../../../services/reports-Gemstone.service";
import { BlobToDownloadFile } from "../../../helper/commanFunction";

import { useSelector } from "react-redux";
import moment from "moment";
import { Button, DatePicker, Select, message } from "antd";
import GemstoneCutComp from "../../ChartsGroup/GemstoneCutComp";

const { RangePicker } = DatePicker;
const { Option } = Select;

const ExtendedGemstoneChartReportsMain = () => {
  const { t } = useTranslation();
  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleCheckDealermembers(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
  }, []);

  const [dealerId, setDealerId] = useState();
  const loginDetials = useSelector((state) => state.loginReducer);

  /*Initial State for Binding Starts*/
  const initialGlobalGemstoneState = {
    dataRangeFrom: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dataRangeTo: moment().format("YYYY-MM-DD"),
    SelectedGemstoneValue: "All",
    retailerIds: [],
    vendorIds: [],
  };
  /*Initial State for Binding Ends*/

  /*React Binding Starts*/
  const [globalGemstones, setGlobalGemstone] = useState(
    initialGlobalGemstoneState
  );
  const [forDealer, setForDealer] = useState("");
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [checkingMembership, setCheckingMembership] = useState(true);
  const [report, setReport] = useState(null);
  const [loadError, setLoadError] = useState(false);

  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [key, setKey] = useState(true);
  const [downloadingPdf, setDownloadingPdf] = useState(false);
  // Each chart card's current Donut/Bar toggle + the Shape noise-filter
  // toggle, so Download PDF renders whichever view is on screen (same as
  // ExtendedDiamondChartReportsMain.js).
  const [chartViews, setChartViews] = useState({});
  const [noiseFilters, setNoiseFilters] = useState({ Shape: true });
  /*React Binding Ends*/

  /*DatePicker Binding Starts*/
  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setGlobalGemstone((prevState) => ({
        ...prevState,
        dataRangeFrom: dateStrings[0],
        dataRangeTo: dateStrings[1],
      }));
    }
  };
  /*DatePicker Binding Ends*/

  /*API Binding Starts*/
  const handleCheckDealermembers = (id) => {
    try {
      let inputData = {
        dealerID: id,
      };

      ReportsGemstoneService.CheckDealermembers(inputData)
        .then((response) => {
          var message = response?.data?.message;
          var responseData = response?.data?.responseData;

          let forDealer = 2;
          if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
              "VendorGemstone" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Vendor"
          ) {
            forDealer = 1;
          } else if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
              "Retailer" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Combined"
          ) {
            forDealer = 2;
          }

          if (message === "Success") {
            if (responseData) {
              setForDealer(forDealer);
            } else {
              setForDealer("");
            }
            setCheckingMembership(false);
            handleLoadExtendedGemstoneChartReports(id, forDealer);
          } else {
            setForDealer("");
            setCheckingMembership(false);
          }
        })
        .catch((error) => {
          setForDealer("");
          setCheckingMembership(false);
        });
    } catch (error) {
      setForDealer("");
      setCheckingMembership(false);
    }
  };

  const handleLoadExtendedGemstoneChartReports = (dealerId, forDealer) => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalGemstones.dataRangeFrom
          ? moment(globalGemstones.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalGemstones.dataRangeTo
          ? moment(globalGemstones.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        retailerIds: globalGemstones.retailerIds.toString(),
        vendorIds: globalGemstones.vendorIds.toString(),
        SelectedGemstoneValue: globalGemstones.SelectedGemstoneValue,
        reportName: "ExtendedGemstoneCharts",
      };
      setLoadChartReportsLoading(true);
      setLoadError(false);

      ReportsGemstoneService.LoadExtendedGemstoneChartReports(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          setLoadChartReportsLoading(false);
          if (message === "Success" && Object.keys(responseData).length !== 0) {
            setReport(responseData);
            setKey(!key);
          } else {
            setReport(null);
            setLoadError(true);
          }
        })
        .catch((error) => {
          setLoadChartReportsLoading(false);
          setReport(null);
          setLoadError(true);
        });
    } catch (error) {
      setLoadChartReportsLoading(false);
      setReport(null);
      setLoadError(true);
    }
  };

  // Download PDF - same filters as handleLoadExtendedGemstoneChartReports so
  // the PDF reflects exactly what's charted.
  const handleDownloadPdf = () => {
    let inputData = {
      dealerID: dealerId ? dealerId.toString() : "",
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalGemstones.dataRangeFrom
        ? moment(globalGemstones.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalGemstones.dataRangeTo
        ? moment(globalGemstones.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      SelectedGemstoneValue: globalGemstones.SelectedGemstoneValue,
      barViewDimensions: Object.keys(chartViews)
        .filter((dim) => chartViews[dim] === "bar")
        .join(","),
      hideShapeNoise: noiseFilters.Shape,
    };
    setDownloadingPdf(true);
    ReportsGemstoneService.ExportActivityPdf(inputData)
      .then((response) => {
        setDownloadingPdf(false);
        const filename = `Gemstone_Activity_${globalGemstones.dataRangeFrom}_${globalGemstones.dataRangeTo}.pdf`;
        BlobToDownloadFile(response.data, filename, "pdf");
      })
      .catch(() => {
        setDownloadingPdf(false);
        message.error(t("Failed to generate PDF. Please try again."));
      });
  };

  /*API Binding Ends*/

  const handleOnChange = (e, isSelect, name) => {
    setGlobalGemstone({
      ...globalGemstones,
      [name]: e,
    });
  };

  const handleApplyFilter = () => {
    handleCheckDealermembers(dealerId);
    setIsApplyFilter(!isApplyFilter);
  };

  return (
    <React.Fragment>
      <div className="pendjewelreq__section form__fields">
        <div className="row magento__mapping">
          <div className="col-md-12">
            <div className="edr-pagehead-row">
              <div className="edr-pagehead">
                <h1 className="edr-pagehead-title">
                  {t("Extended Gemstone Chart Reports")}
                </h1>
                <div className="edr-pagehead-sub">
                  {t("Search & engagement analytics")} ·{" "}
                  {moment(globalGemstones.dataRangeFrom).format("MMM D, YYYY")}{" "}
                  – {moment(globalGemstones.dataRangeTo).format("MMM D, YYYY")}
                </div>
              </div>
              <div className="edr-pagehead-actions">
                <Button className="ghost-btn" onClick={handleDownloadPdf} loading={downloadingPdf}>
                  <i className="fa fa-download"></i> {t("Download PDF")}
                </Button>
                <button className="primary-btn" onClick={handleApplyFilter}>
                  {t("Apply Filter")}
                </button>
              </div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="row edr-filters">
              <div className="col-md-3">
                <div className="input__block dataRange-input-block datepicker__block">
                  <label> {t("Date Range")} </label>
                  <RangePicker
                    className="date-range-input"
                    ranges={{
                      Today: [moment(), moment()],
                      Yesterday: [
                        moment().subtract(1, "days"),
                        moment().subtract(1, "days"),
                      ],
                      "Last 7 Days": [moment().subtract(7, "days"), moment()],
                      "Last 30 Days": [moment().subtract(30, "days"), moment()],
                      "This Month": [
                        moment().startOf("month"),
                        moment().endOf("month"),
                      ],
                      "Last Month": [
                        moment().subtract(1, "month").startOf("month"),
                        moment().subtract(1, "months").endOf("month"),
                      ],
                      "Last 90 Days": [moment().subtract(90, "days"), moment()],
                      "Year To Date": [moment().startOf("year"), moment()],
                    }}
                    format={"MM-DD-YYYY"}
                    onChange={onDateChange}
                    defaultValue={[moment().subtract(30, "days"), moment()]}
                    defaultPickerValue={[moment().subtract(30, "days"), moment()]}
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="input__block">
                  <label> {t("Select Gemstone")} </label>
                  <Select
                    className="border__grey"
                    placeholder={t("All")}
                    showSearch
                    name="SelectedGemstoneValue"
                    optionFilterProp="children"
                    value={
                      globalGemstones.SelectedGemstoneValue
                        ? globalGemstones.SelectedGemstoneValue
                        : null
                    }
                    onChange={(e) =>
                      handleOnChange(e, "select", "SelectedGemstoneValue")
                    }
                  >
                    <Option value="All"> {t("All")} </Option>
                    <Option value="Mined"> {t("Mined Gemstone")} </Option>
                  </Select>
                </div>
              </div>
            </div>
          </div>

          {forDealer && loadError && (
            <div className="col-md-12">
              <div className="no-report-render">
                <div className="desc-space">
                  <h4 className="text-center">
                    {t("Couldn't load the report. Please try again.")}
                  </h4>
                </div>
              </div>
            </div>
          )}

          {(forDealer || checkingMembership) && !loadError && (
            <div className="col-md-12">
              <ReportKpiBand
                report={report}
                loading={checkingMembership || LoadChartReportsLoading}
                dataRangeFrom={globalGemstones.dataRangeFrom}
                dataRangeTo={globalGemstones.dataRangeTo}
              />
              <ReportInsight report={report} />
            </div>
          )}

          {(forDealer || checkingMembership) && !loadError && (
            <div className="col-md-12">
              <ReportTabs
                overview={
                  <>
                    <div className="col-lg-6">
                      <GemstoneReportsShapeComp
                        data={report?.GemstoneShapeSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                        onHideNoiseChange={(v) => setNoiseFilters((prev) => ({ ...prev, Shape: v }))}
                      />
                    </div>
                    <div className="col-lg-6">
                      <GemstoneReportsColorComp
                        data={report?.GemstoneColorSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                        onChartTypeChange={(v) => setChartViews((prev) => ({ ...prev, Color: v === "bar" ? "bar" : "donut" }))}
                      />
                    </div>
                  </>
                }
                attributes={
                  <>
                    <div className="col-lg-12">
                      <GemstoneReportsCertificateComp
                        data={report?.GemstoneCertificateSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                        onChartTypeChange={(v) => setChartViews((prev) => ({ ...prev, Certificate: v === "bar" ? "bar" : "donut" }))}
                      />
                    </div>
                    <div className="col-lg-12">
                      <GemstoneReportsClarityComp
                        data={report?.GemstoneClaritySearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                        onChartTypeChange={(v) => setChartViews((prev) => ({ ...prev, Clarity: v === "bar" ? "bar" : "donut" }))}
                      />
                    </div>
                    <div className="col-lg-12">
                      <GemstoneReportsGemTypeComp
                        data={report?.GemstoneGemTypeSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                        onChartTypeChange={(v) => setChartViews((prev) => ({ ...prev, GemType: v === "bar" ? "bar" : "donut" }))}
                      />
                    </div>
                  </>
                }
                commercial={ 
                  <>
                    <div className="col-lg-6">
                      <GemstoneReportsPriceComp
                        data={report?.GemstonePrice}
                        loading={checkingMembership || LoadChartReportsLoading}
                        onChartTypeChange={(v) => setChartViews((prev) => ({ ...prev, Price: v === "bar" ? "bar" : "donut" }))}
                      />
                    </div>
                    <div className="col-lg-6">
                      <GemstoneReportsSizeComp
                        data={report?.GemstoneSizeSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                        onChartTypeChange={(v) => setChartViews((prev) => ({ ...prev, Size: v === "bar" ? "bar" : "donut" }))}
                      />
                    </div>
                  </>
                }
                trend={
                  <div className="col-lg-12">
                    <GemstoneReportsClicksComp
                      data={report?.GemstoneClicks}
                      loading={checkingMembership || LoadChartReportsLoading}
                      onChartTypeChange={(v) => setChartViews((prev) => ({ ...prev, Clicks: v === "bar" ? "bar" : "line" }))}
                    />
                  </div>
                }
              />
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ExtendedGemstoneChartReportsMain;
